export default __webpack_public_path__ + "static/media/auth.dd66c1df.svg";